import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { twMerge } from 'tailwind-merge';

interface Props extends Omit<DropdownMenu.DropdownMenuItemProps, 'children'> {
  children?:
    | React.ReactNode
    | [React.ReactNode, React.ReactNode]
    | [React.ReactNode, React.ReactNode, React.ReactNode];
}

export function Item(props: Props) {
  const { className, children, ...rest } = props;

  const isGrid = Array.isArray(children) && children.length < 4;
  const numCols = Array.isArray(children) ? children.length : 1;

  return (
    <DropdownMenu.Item
      className={twMerge(
        'cursor-pointer',
        'outline-none',
        'p-1',
        'rounded',
        'transition-colors',
        'active:bg-neutral-300',
        'focus:bg-neutral-200',
        'hover:bg-neutral-200',
        isGrid && 'grid gap-x-1 items-center',
        numCols === 2 && 'grid-cols-[max-content_1fr]',
        numCols === 3 && 'grid-cols-[max-content_1fr_max-content]',
        className,
      )}
      {...rest}
    >
      {children}
    </DropdownMenu.Item>
  );
}
